import React from 'react';
import { CheckCircle } from 'lucide-react';
import { AITaskList } from '../components/ai/AITaskList';

const TasksPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white">
      {/* Page Header */}
      <div className="backdrop-blur-2xl bg-white/60 dark:bg-slate-900/60 border-b border-slate-200/50 dark:border-slate-700/30">
        <div className="px-2 sm:px-4 lg:px-8 py-3 sm:py-4 lg:py-6">
          <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-green-500/10 border border-green-500/20 rounded-lg sm:rounded-xl lg:rounded-2xl flex items-center justify-center">
              <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-green-600 dark:text-green-400" />
            </div>
            <div>
              <h1 className="text-lg sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-500 to-purple-500 bg-clip-text text-transparent dark:from-white dark:via-indigo-200 dark:to-purple-200">
                Tasks
              </h1>
              <p className="text-slate-600 dark:text-slate-300 text-xs sm:text-sm lg:text-base">
                Track your AI processing tasks and results
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-2 sm:px-4 lg:px-8 py-2 sm:py-4 lg:py-6 space-y-6">
        {/* Media Library Banner */}
        <div className="bg-gradient-to-r from-indigo-50 via-white to-purple-50 dark:from-indigo-900/20 dark:via-slate-800/50 dark:to-purple-900/20 border border-indigo-200/50 dark:border-indigo-800/30 rounded-2xl p-6 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #30b3dd 0%, #4a298a 50%, #30b3dd 100%)', boxShadow: '0 4px 15px rgba(48, 179, 221, 0.3)' }}>
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black dark:text-white">
                  Generated Content Available
                </h3>
                <p className="text-sm text-black dark:text-gray-300">
                  All your completed AI-generated content is saved in the Media Library
                </p>
              </div>
            </div>
            <button
              onClick={() => window.location.href = '/app/media'}
              className="px-6 py-2.5 text-white font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              style={{ 
                background: 'linear-gradient(135deg, #30b3dd 0%, #4a298a 50%, #30b3dd 100%)',
                backgroundSize: '200% 200%',
                backgroundPosition: 'left center',
                boxShadow: '0 4px 15px rgba(48, 179, 221, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundPosition = 'right center';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(48, 179, 221, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundPosition = 'left center';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(48, 179, 221, 0.3)';
              }}
            >
              View Media Library
            </button>
          </div>
        </div>

        <AITaskList />
      </div>
    </div>
  );
};

export default TasksPage;